/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Eisox_ProviderInputs */



/**
* | output |
* | --- |
* | "Software replacement information" |
*
* @param {Intervention_Plan_Eisox_ProviderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_eisox_provider = /** @type {((inputs?: Intervention_Plan_Eisox_ProviderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Eisox_ProviderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Software replacement information")
	return /** @type {LocalizedString} */ ("Information remplacement informatique")
});